export enum FeedbackForFeature {
  AdvancedDeletion = `Advanced Deletion`,
  BehaviorMetrics = `Behavior Metrics`,
  Boards = `Boards`,
  Home = `Home`,
  Browse = `Search & Discover`,
  NewDropdowns2021 = `New Dropdowns 2021`,
  LiveviewEventInspector = `Liveview Event Inspector`,
  SidebarQB = `Query Panel`,
  General = `General`,
  FoundationalTemplates = `Foundational Templates`,
  OnboardingChecklist = `Onboarding Checklist`,
  Spark = `Spark`,
  StarterBoard = `Starter Board`,
  LexiconUpdates = `Lexicon Updates`,
  WarehouseImports = `Warehouse Imports`,
  SessionReplay = `Session Replay`,
  Localization = `Localization`,
}

export enum FeedbackType {
  Dealbreaker = `dealbreaker`,
  PainPoint = `pain_point`,
  Beta = `beta`,
  NotWorking = `not_working`,
}

export enum Sentiment {
  Positive = `positive`,
  Negative = `negative`,
}
